// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2caeQ","logo":"Header_logo__3oS9I","activities":"Header_activities__pg5ng"};